export enum TopUpAmountTypeId {
  TopUpAmount = 1,
  AutoTopUpThreshHold = 2,
  AutoTopUpTopUpAmount = 3,
  TransferAmounts = 4,
  TopUpTicketAmount = 5,
  TopUpMobile = 6,
  CharityDonation = 7
}
